import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const labelServiceImage = {
    updateLabelImageStatusNew,
    updateLabelImageStatusImageNew,
};

const MODULE = {
    LABEL: 'rnd-new-product-label-images',
    LABELIMAGE: 'new-rnd-product-label-images',
};

const API_URL = API.BASE_URL + '/v1';

export async function updateLabelImageStatusNew(data) {
    const requestOptions = {
        is_active: data.isActive
    };

    return apiHelper(API_URL).patch(`/${MODULE.LABEL}/${data.id}`, requestOptions);
}

export async function updateLabelImageStatusImageNew(data) {
    const requestOptions = {
        is_active: data.isActive
    };

    return apiHelper(API_URL).patch(`/${MODULE.LABELIMAGE}/${data.id}`, requestOptions);
}